import React from 'react';
export function About() {
  return <section className="py-24 md:py-32 px-6 bg-gray-50/50" data-id="element-1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-2">
        <h2 className="text-3xl md:text-4xl mb-12 text-navy" data-id="element-3">Our Approach</h2>

        <div className="space-y-8 text-lg md:text-xl text-gray-600 font-light leading-relaxed font-sans" data-id="element-4">
          <p data-id="element-5">
            At MFC Investco, we believe that true value is built over decades,
            not quarters. Our philosophy is rooted in patience, discipline, and
            a deep sense of responsibility to the capital we steward and the
            communities we serve.
          </p>
          <p data-id="element-6">
            We operate at the intersection of private investment and strategic
            philanthropy, seeking opportunities where capital can catalyze
            sustainable growth and positive change. Our partnerships are built
            on a foundation of absolute discretion and aligned values.
          </p>
          <p data-id="element-7">
            Trust is our currency. We prioritize long-term relationships over
            short-term gains, ensuring that every decision reflects our
            commitment to integrity and generational stewardship.
          </p>
        </div>
      </div>
    </section>;
}